import React, { Component } from 'react';
import { Button, Modal } from 'carbon-components-react';
import moment from 'moment';
import { toast } from 'react-toastify';
import { insertDmService, getDmService } from '../../../../services/Api';
import UnidAndStores from '../../../../components/trades/UnitsAndStores';
import { Card } from '../../../../components';

class ConfirmRequestClipboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stores: [],
      selectedUnit: null,
      selectedStore: null,
      currentDate: null,
      numberRequest: null,
      modalConfirm: false,
    };
  }

  componentWillMount() {
    this.setDateNow();
  }

  setDateNow = () => {
    this.setState({
      currentDate: moment().format('DD/MM/YYYY'),
    });
  };

  openModal = () => {
    this.setState({
      modalConfirm: true,
    });
  };

  closeModal = () => {
    this.setState({
      modalConfirm: false,
    });

    window.location.href = '/trade/pranchetas';
  };

  postClipboards = () => {
    const { selectedUnit, selectedStore } = this.state;
    if (selectedUnit && selectedStore) {
      const { cleark } = this.props;
      const urlEdit = '/Pedido/GeraPedidoMaterial';
      const formData = {
        TipoCadastro: { id: 4 },
        TipoAssistente: { id: 2 },
        Atendente: { id: cleark.id },
        Unidade: { Id: selectedUnit.id },
        Loja: { Id: selectedStore.id },
      };

      insertDmService(urlEdit, formData)
        .then(res => {
          this.setState({ numberRequest: res });
          this.openModal();
        })
        .catch(err => {
          toast.warn('Um erro inesperado ocorreu. Tente novamente mais tarde.');
          console.log(err);
        });
    } else {
      toast.warn('Você precisa selecionar unidade e loja');
    }
  };

  loadStores = async unitId => {
    const { cleark } = this.props;
    try {
      const data = await getDmService(`/Atendente/GetLojas/${cleark.id}?idUnidade=${unitId}`);
      const arrStores = [];
      data.forEach(item => {
        arrStores.push({
          id: item.id,
          label: item.nome,
        });
      });

      this.setState({
        stores: arrStores,
      });
    } catch (error) {
      console.error(error);
    }
  };

  onChangeUnit = obj => {
    this.setState({
      selectedUnit: obj,
      selectedStore: null,
      // error: null,
    });

    if (obj) {
      this.loadStores(obj.id);
    }
  };

  onChangeStore = obj => {
    this.setState({
      selectedStore: obj,
      // error: null,
    });
  };

  render() {
    const { cleark, returnSearch } = this.props;
    const {
      stores,
      selectedUnit,
      selectedStore,
      currentDate,
      numberRequest,
      modalConfirm,
    } = this.state;

    return (
      <Card className="center-box box-padd">
        <div className="bx--row">
          <div className="bx--col-xs-12">
            <p className="description-option-title ">Confirme sua solicitação de prancheta</p>
            <p className="description-option-desc">
              Você tem certeza que deseja socilitar uma prancheta para a atendente
              {' '}
              <strong>
                {' '}
                {cleark.label}
                {' '}
              </strong>
              ?
            </p>
            <div className="mg-top-40 confirm-troca">
              <p className="mg-top-20">
                <strong>Prancheta </strong>
                {' '}
                <span>
                  {' '}
                  {currentDate}
                  {' '}
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className="bx--row">
          <div className="stores-units-trades bx--col-xs-12">
            <h2>Qual a loja principal deste atendente.</h2>
            <p>
              Selecione abaixo a loja principal de
              {' '}
              <span>
                {' '}
                {cleark.label}
                {' '}
              </span>
            </p>
            <div className="mg-top-20">
              <UnidAndStores
                onChangeStore={this.onChangeStore}
                onChangeUnit={this.onChangeUnit}
                stores={stores}
                urlUnits={`/Atendente/GetUnidades/${cleark.id}`}
                selectedUnit={selectedUnit}
                selectedStore={selectedStore}
              />
            </div>
          </div>
        </div>

        <div className="bx--row">
          <div className="bx--col-xs-12 v-md-margin buttons-footer-requests">
            <Button onClick={() => this.postClipboards()}> Finalizar Pedido </Button>
            <Button kind="ghost" onClick={returnSearch} className="h-sm-margin">
              Voltar
            </Button>
          </div>
        </div>

        <Modal
          onRequestClose={() => this.closeModal()}
          onRequestSubmit={() => this.closeModal()}
          iconDescription="Fechar"
          className="some-class confirm-trade"
          open={modalConfirm}
          modalHeading="Pedido feito com sucesso."
          primaryButtonText="Ok, Entendi"
        >
          <div className="warning-modal-txt">
            <p>
              <strong>
                {`Número do seu pedido ${numberRequest}.`}
              </strong>
            </p>
            <p className="finalizado-pedido">
              A qualquer momento você poderá acompanhá-lo clicando em
              {' '}
              <a className="notifications pointer" href="/pedidos">
                <i className="assignment" />
              </a>
            </p>
            <p className="finalizado-pedido">Prazo de entrega: 5 dias úteis</p>
          </div>
        </Modal>
      </Card>
    );
  }
}

export default ConfirmRequestClipboard;



// WEBPACK FOOTER //
// ./src/screens/client/trades/clipboards/ConfirmRequestClipboard.jsx